import { CanActivateFn } from '@angular/router';
import { isDevMode } from '@angular/core';

export const devGuardFn: CanActivateFn = () => {
  if (isDevMode()) {
    return true; // Allow access in development mode
  }
  console.warn('Access to this route is restricted in production mode.');
  return false; // Restrict access in production mode
};
